// Pola i przyciski panelu. Wydzielone, bo te same cztery klasy powtarzały się
// w ośmiu widokach i za każdym razem odrobinę inaczej.
//
// Przyciski z packages/ui są w rozmiarze produktu - w tabeli panelu byłyby za
// duże, więc wiersz tabeli ma własny, mniejszy wariant.

import type {
  ButtonHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import type { InputHTMLAttributes } from "react";

const CONTROL =
  "rounded-card border border-line bg-surface px-2.75 py-2.25 text-base text-ink placeholder:text-ink-soft/60";

/** Etykieta nad polem. Zawsze jest - placeholder nie jest etykietą. */
export function Labeled({
  label,
  hint,
  children,
  className,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <label className={`flex flex-col gap-1 text-base text-ink-soft ${className ?? ""}`}>
      {label}
      {children}
      {hint && <span className="text-xs text-ink-soft">{hint}</span>}
    </label>
  );
}

export function TextInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={`${CONTROL} ${className ?? ""}`} {...props} />;
}

export function TextArea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={`${CONTROL} resize-y ${className ?? ""}`} {...props} />;
}

/**
 * Lista wyboru w formularzu, nie w pasku filtrów. Filtry mają własny `Select`
 * w components/Page - tam pusta wartość znaczy "wszystkie", tutaj "jeszcze nie
 * wybrano", więc pozycję pustą podaje wywołujący.
 */
export function SelectInput({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={`${CONTROL} ${className ?? ""}`} {...props} />;
}

/**
 * Przycisk w wierszu tabeli albo pod polem. Bordo zostawiamy jednej akcji
 * głównej na widok, więc tutaj jest wyłącznie obramowanie.
 */
export function SmallButton({
  className,
  type = "button",
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={`inline-flex items-center gap-1.5 rounded-card border border-line bg-surface px-3 py-1.5 text-xs text-ink transition-colors hover:border-ink-soft disabled:cursor-not-allowed disabled:opacity-50 ${
        className ?? ""
      }`}
      {...props}
    >
      {children}
    </button>
  );
}

/** Akcja poboczna wyglądająca jak odnośnik - bez ramki, żeby nie krzyczała. */
export function LinkButton({
  className,
  type = "button",
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={`inline-flex items-center gap-1.5 text-xs text-ink-soft underline underline-offset-3 hover:text-ink disabled:cursor-not-allowed disabled:opacity-50 ${
        className ?? ""
      }`}
      {...props}
    >
      {children}
    </button>
  );
}
